import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_VEHICLES_CATEGORIES_DATA, FETCH_VEHICLES_CATEGORIES_EDIT_DATA } from "./actionTypes";
import {
  fetchVehiclesCategoriesSuccess,
  fetchVehiclesCategoriesFailure,
  fetchVehiclesCategoriesEditSuccess,
  fetchVehiclesCategoriesEditFailure,
} from "./actions";

function* fetchVehiclesCategoriesDataSaga() {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + "/api/web/vehicles-categories",{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchVehiclesCategoriesSuccess(response.data));
  } catch (error) {
    yield put(fetchVehiclesCategoriesFailure(error.message));
  }
}

function* fetchVehiclesCategoriesEditDataSaga(action) {
  try {
    const id = action.payload;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + `/api/web/vehicles-categories/${id}`,{
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      "Content-Type": "application/json"
    },
  });
    yield put(fetchVehiclesCategoriesEditSuccess(response.data));
  } catch (error) {
    yield put(fetchVehiclesCategoriesEditFailure(error.message));
  }
}

export default function* vehiclesCategoriesSaga() {
  yield takeEvery(FETCH_VEHICLES_CATEGORIES_DATA, fetchVehiclesCategoriesDataSaga);
  yield takeEvery(FETCH_VEHICLES_CATEGORIES_EDIT_DATA, fetchVehiclesCategoriesEditDataSaga);
}
